import React from "react";
import Admissions from "../components/sections/Admissions";
import Contact from "../components/sections/Contact";

const AdmissionsPage = () => (
  <main className="pt-24 pb-10 min-h-screen" data-testid="admissions-page">
    <div className="text-center max-w-2xl mx-auto px-4 pt-8">
      <span className="text-brand-blue font-heading font-bold tracking-wider uppercase text-xs">Admissions</span>
      <h1 className="font-heading text-4xl sm:text-5xl font-bold mt-2 mb-3">Join our school family</h1>
      <p className="text-[color:var(--text-secondary)]">
        Our admissions process is warm, simple and family-friendly. Here's how it works.
      </p>
    </div>
    <Admissions />
    <Contact />
  </main>
);

export default AdmissionsPage;
